var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{key:_vm.isResourceShow,ref:"cascader",style:(_vm.css),attrs:{"options":_vm.options,"props":_vm.props,"placeholder":_vm.placeholder,"filterable":"","size":"small","clearable":""},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/TagSelect/index.vue?vue&type=template&id=42ab5ddc&
// module id = null
// module chunks = 